// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"39b5b882","879":"7eda7c86"}[chunkId] + ".chunk.js";
};